import { isNull } from '@susu/null'
import { isUndefined } from '@susu/undefined'

export const removeLocaleFromPathname = (pathname: string): string => {
  const pathSegments = pathname.split('/').filter(Boolean)

  if (pathSegments.length > 0) {
    pathSegments.shift()
  }

  return `/${pathSegments.join('/')}`
}

export const removeLocaleFromUrl = (url: URL): string => {
  if (isUndefined(url) || isNull(url)) {
    return ''
  }

  const pathname = url.pathname
  const pathnameWithoutLocale = removeLocaleFromPathname(pathname)

  return `${url.origin}${pathnameWithoutLocale}${url.search}${url.hash}`
}
